import {
  Button,
  Column,
  Heading,
  Icon,
  Row,
  Sheet,
  Thumbnail,
} from "@amzn/meridian";
import React from "react";
import { BADGE_PHOTO_THUMBNAIL_URL } from "src/config/external-links";
import { useAppDispatch, useAppSelector } from "src/store/store";
import { setProfileSheetOpen } from "src/store/uiSlice";
import closeSmallTokens from "@amzn/meridian-tokens/base/icon/close-small";

const ProfileSideSheet = () => {
  const { firstName, lastName, alias } = useAppSelector((state) => state.user);
  const { isProfileSheetOpen } = useAppSelector((state) => state.ui);
  const dispatch = useAppDispatch();

  return (
    <Sheet
      type="overlay"
      side="end"
      open={isProfileSheetOpen}
      onClose={() => dispatch(setProfileSheetOpen(false))}
    >
      <Column spacing="300" spacingInset={"400"} height={"100vh"}>
        <Row alignmentHorizontal="end">
          <Button
            onClick={() => dispatch(setProfileSheetOpen(false))}
            type="icon"
          >
            <Icon tokens={closeSmallTokens}>Close sheet</Icon>
          </Button>
        </Row>
        <Column>
          <Row alignmentHorizontal="center">
            <Thumbnail
              source={`${BADGE_PHOTO_THUMBNAIL_URL}${alias}`}
            ></Thumbnail>
          </Row>
          <Heading level={5} alignment="center">
            {`${firstName} ${lastName}`}
          </Heading>
        </Column>
      </Column>
    </Sheet>
  );
};

export default ProfileSideSheet;
